/**
 * Average Daily Range (ADR)
 *
 * Average of (High − Low) over N periods.
 * Useful for gauging expected daily price movement.
 *
 * Category: Volatility | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const adrIndicator: IndicatorDefinition = {
  id: "adr",
  name: "Average Daily Range",
  shortName: "ADR",
  category: "volatility",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 14, min: 2, max: 200 },
  ],
  plots: [
    { key: "adr", label: "ADR", color: "#26A69A", style: "line", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const adrData: { time: number; value: number }[] = [];

    for (let i = period - 1; i < candles.length; i++) {
      let sum = 0;
      for (let j = i - period + 1; j <= i; j++) {
        sum += candles[j].high - candles[j].low;
      }
      adrData.push({ time: candles[i].time, value: sum / period });
    }

    return [{ key: "adr", data: adrData }];
  },
};
